const ElementCreator = require('./element');
const ShapeSetter = require('../../setters/shape');

module.exports = GraphicCreator;

function GraphicCreator () {}

GraphicCreator.prototype = new ElementCreator();
GraphicCreator.prototype.constructor = GraphicCreator;

GraphicCreator.prototype.initialize = function () {
  ElementCreator.prototype.initialize.call(this);

  _.bindAll(this, 'updateContent', 'defineColorGroups');
  _.extend(this.defaults, {
    content: null
  });
};

GraphicCreator.prototype.updateContent = function (oldElement, data) {
  INKIVE.SVGElementLoading.hide(oldElement);
  const content = isBase64(data.content)
    ? Base64.decode(data.content)
    : data.content;
  const newAttributes = this.getSmartAssetsData(oldElement);
  const newElement = INKIVE.Helpers.getStickerFromString(
    content, { keepClasses: ($(oldElement).is('.logo') || data.sticker_id) }
  );

  this.canvas.selectOnly([oldElement]);

  if (!newElement) {
    return;
  }

  newElement.classList = _(oldElement.classList).without('selected').join(' ');

  this.editor.replaceElement(oldElement, newElement, true, true, true);

  if (oldElement.hasAttribute('from-library')) {
    newElement.setAttribute('from-library', 'true');
  }

  if (data.thumb_src) newAttributes['data-thumb-src'] = data.thumb_src;
  svgedit.utilities.assignAttributes(newElement, newAttributes);

  const shapes = INKIVE.DesignFacade.get(newElement.id, 'shapes');
  this.defineColorGroups(newElement, { shapes });

  this.canvas.runExtensions('selectedChanged');

  return newElement;
};

GraphicCreator.prototype.defineColorGroups = function (element, data) {
  if (!data?.shapes) {
    return [];
  }

  if (!element) return;

  const shapeSetter = new ShapeSetter();
  shapeSetter.initialize();

  let shapes = Object.values(data.shapes);

  const colorGroups = new Array([...shapes].length).fill(null);

  const nonColorGroupShapes = shapes.map((shape, i) => {
    const group = Number(shape.fill.colorGroup);
    if (!isNaN(group) && group < colorGroups.length) {
      colorGroups[group] = shape.fill.color;
    }

    return shape;
  }).filter((shape, i) => {
    return !colorGroups[shape.fill.colorGroup];
  });

  const nonGroupColors = [...new Set(nonColorGroupShapes.map(shape => shape.fill.color))].filter(Boolean);

  const remainingGroupIndex = colorGroups.map((group, index) => !group ? index : null).filter(group => group !== null);
  nonGroupColors.forEach((color, i) => {
    colorGroups[remainingGroupIndex[i]] = color;
  });

  const colorColorGroupMapping = remainingGroupIndex.reduce((mapping, index) => {
    if (colorGroups[index]) {
      mapping[colorGroups[index]] = `${index}`;
    }

    return mapping;
  }, {});

  shapes = shapes.map(shape => {
    if (!shape.fill.colorGroup && shape.fill.color) {
      shape.fill.colorGroup = colorColorGroupMapping[shape.fill.color];
    }
    return shape;
  });

  shapes.forEach((shape) => {
    shapeSetter.updateColorGroup(element?.querySelector(`#${shape.id}`), { colorGroup: shape.fill.colorGroup });
  });

  return shapes;
};

function isBase64 (str) {
  return /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/.test(str) ||
    str.indexOf('<') === -1;
}
